import { z } from 'zod';
import { UntrackedAssetType, UntrackedAssetTypeSchema } from './cases-api.dto';

export { UntrackedAssetType, UntrackedAssetTypeSchema };

export const InstrumentTaxonomyClassImageDtoSchema = z.object({
  id: z.number(),
  mimeType: z.string(),
});
export type InstrumentTaxonomyClassImageDto = z.infer<typeof InstrumentTaxonomyClassImageDtoSchema>;

export const InstrumentTaxonomyClassDtoSchema = z.object({
  id: z.number(),
  name: z.string(),
  category: z.string().nullable().optional(),
  images: z.array(InstrumentTaxonomyClassImageDtoSchema).default([]),
});
export type InstrumentTaxonomyClassDto = z.infer<typeof InstrumentTaxonomyClassDtoSchema>;

export const UntrackedAssetCatalogDtoSchema = z.object({
  id: z.string(),
  type: UntrackedAssetTypeSchema,
  name: z.string(),
  productNumber: z.string().nullable().optional(),
  manufacturer: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
  cost: z.number().nullable().optional(),
  isActive: z.boolean(),
  metadata: z.record(z.unknown()).nullish(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
  instrumentTaxonomyClassId: z.number().nullable().optional(),
  instrumentTaxonomyClassName: z.string().nullable().optional(),
  instrumentTaxonomyCategoryName: z.string().nullable().optional(),
});
export type UntrackedAssetCatalogDto = z.infer<typeof UntrackedAssetCatalogDtoSchema>;

export const PaginatedUntrackedAssetCatalogResponseDtoSchema = z.object({
  data: z.array(UntrackedAssetCatalogDtoSchema),
  total: z.number(),
  page: z.number(),
  limit: z.number(),
});
export type PaginatedUntrackedAssetCatalogResponseDto = z.infer<
  typeof PaginatedUntrackedAssetCatalogResponseDtoSchema
>;

export interface UntrackedAssetCatalogFilterParams {
  search?: string;
  type?: UntrackedAssetType;
  page?: number;
  limit?: number;
}

export interface CreateUntrackedAssetCatalogDto {
  type: UntrackedAssetType;
  name: string;
  productNumber: string;
  manufacturer: string;
  description?: string | null;
  cost?: number | null;
  isActive?: boolean;
  metadata?: Record<string, unknown> | null;
}

export interface UpdateUntrackedAssetCatalogDto {
  type?: UntrackedAssetType;
  name?: string;
  description?: string | null;
  cost?: number | null;
  isActive?: boolean;
  metadata?: Record<string, unknown> | null;
}

export interface UpdateUntrackedAssetCatalogTaxonomyDto {
  instrumentTaxonomyClassId: number | null;
}

export const UntrackedAssetCatalogTaxonomyResponseDtoSchema = z.object({
  catalogItemId: z.string(),
  instrumentTaxonomyClassId: z.number().nullable(),
  instrumentTaxonomyClass: z
    .object({
      id: z.number(),
      name: z.string(),
      category: z.string().nullable().optional(),
    })
    .nullable()
    .optional(),
});
export type UntrackedAssetCatalogTaxonomyResponseDto = z.infer<
  typeof UntrackedAssetCatalogTaxonomyResponseDtoSchema
>;

export interface CreateUntrackedAssetCatalogWithTaxonomyDto
  extends CreateUntrackedAssetCatalogDto {
  instrumentTaxonomyClassId?: number | null;
}
